import React, { memo } from 'react';
import { CourseBuilderBlockFormData, CourseBuilderBlockForm } from '../../CourseBuilderForm';
import { R } from '@core/utils/r';
import { SortableHandle, SortableElement } from 'react-sortable-hoc';
import classNames from 'classnames';

export interface SectionItemProps {
  block: CourseBuilderBlockFormData;
  onClick(): void;
  onSettings(): void;
}

export const SectionItem = memo((props: SectionItemProps) => {
  const { block } = props;

  const DragHandle = SortableHandle(() => (
    <a>
      <i className="psi-handle fa fa-grip-vertical mr-2" style={{ cursor: 'move' }} />
    </a>
  ));
  return (
    <div className={classNames('psi-section-item', { notSection: !block.isSection })} onClick={props.onClick}>
      <div style={{ width: '100%', padding: 5, paddingTop: 7, paddingBottom: 7 }} className="d-flex flex-row justify-content-between">
        <DragHandle />
        <span className="text-truncate" style={{ flex: 1 }}>
          {block.title || R.startCase(block.variation)}
        </span>
        <a
          onClick={e => {
            e.stopPropagation();
            props.onSettings();
          }}
        >
          <i className="psi-setting fa fa-cog text-muted"></i>
        </a>
      </div>
    </div>
  );
});

export const SortableSectionItem = SortableElement(SectionItem);
